import { Platform } from 'react-native';
import Constants from 'expo-constants';

// This is the server key because we use the plentiful web servers as a proxy
// So yes, we expose this key to the public but that's ok since the key
// is protected to only allow our servers IP addresses

const googlePlacesApiKey = 'AIzaSyBb8Ih34xVTTBD5eT4OYcGrRjQhrzxERFY';
const unrestrictedGooglePlacesApiKey = 'AIzaSyDQCQYlnm5sZKcEFyMw7G1iqd5UikS8d3c';
const sentryDsn = 'https://cc4bc50bfd5e4d619336905d375fe664@o566812.ingest.sentry.io/6591658';
const statsigSdkKey = 'client-7pEzSYVF5lWBtHJlwXvwM3RKGJRvBzr1kJy0VbFWBHR';

const apiPath = '/api/3.0/';

const EnvConfig = {
  development: {
    apiUrl: `http://${process.env.API_HOST || 'localhost'}:1337${apiPath}`,
    consoleLog: true,
    debugLog: true,
    useSentry: false,
    sentryEnv: 'development',
    googlePlacesApiKey: unrestrictedGooglePlacesApiKey,
    statsigSdkKey,
    statsigEnv: 'development',
    reportIssueUrl: 'https://l-test.plntfl.app/map-issue-dev?organization_id=',
  },
  staging: {
    apiUrl: `https://pantry-dev.plentifulapp.com${apiPath}`,
    consoleLog: true,
    debugLog: true,
    sentryDsn,
    useSentry: true,
    sentryEnv: 'staging',
    googlePlacesApiKey,
    statsigSdkKey,
    statsigEnv: 'staging',
    reportIssueUrl: 'https://l-test.plntfl.app/map-issue-dev?organization_id=',
  },
  production: {
    apiUrl: `https://pantry.plentifulapp.com${apiPath}`,
    consoleLog: false,
    debugLog: false,
    sentryDsn,
    useSentry: true,
    sentryEnv: 'production',
    googlePlacesApiKey,
    statsigSdkKey,
    statsigEnv: 'production',
    reportIssueUrl: 'https://plntfl.app/map-issue?organization_id=',
  },
};

// our environment constants are now defined in app.config.js
// which makes them available in Constants.expoConfig.extra
let APP_ENV = process.env.APP_ENV || 'development';
if (Constants.expoConfig && Constants.expoConfig.extra) {
  APP_ENV = Constants.expoConfig.extra.APP_ENV;
}

export let EnvVars = EnvConfig[APP_ENV];
switch (Platform.OS) {
  case 'android':
    if (__DEV__) {
      EnvVars.apiUrl = `http://${process.env.API_HOST || '10.0.2.2'}:1337${apiPath}`;
    }
    break;
  case 'ios':
    if (__DEV__) {
      EnvVars.apiUrl = `http://${process.env.API_HOST || 'localhost'}:1337${apiPath}`;
    }
    break;
  case 'web':
    const host = window.location.hostname;
    if (host === 'localhost') {
      EnvVars = EnvConfig.development;
    } else if (host === 'app-dev.plentifulapp.com') {
      EnvVars = EnvConfig.staging;
    } else if (host === 'dkfb53ie66z6p.cloudfront.net') {
      EnvVars = EnvConfig.staging;
    } else if (host === 'app-dev-rn.s3-website-us-east-1.amazonaws.com') {
      EnvVars = EnvConfig.staging;
    } else {
      EnvVars = EnvConfig.production;
    }
}
